import ArcIn from './ArcIn';
import BlurIn from './BlurIn';
import ShuttersIn from './ShuttersIn';
import BounceIn from './BounceIn';
import CurveIn from './CurveIn';
import CircleIn from './CircleIn';
import DropIn from './DropIn';
import ExpandIn from './ExpandIn';
import FadeIn from './FadeIn';
import FlipIn from './FlipIn';
import FloatIn from './FloatIn';
import FoldIn from './FoldIn';
import GlideIn from './GlideIn';
import GlitchIn from './GlitchIn';
import GrowIn from './GrowIn';
import PunchIn from './PunchIn';
import ShapeIn from './ShapeIn';
import RevealIn from './RevealIn';
import SlideIn from './SlideIn';
import SpinIn from './SpinIn';
import TiltIn from './TiltIn';
import TurnIn from './TurnIn';
import WinkIn from './WinkIn';
export const entranceAnimations = {
  ArcIn,
  BlurIn,
  ShuttersIn,
  BounceIn,
  CurveIn,
  CircleIn,
  DropIn,
  ExpandIn,
  FadeIn,
  FlipIn,
  FloatIn,
  FoldIn,
  GlideIn,
  GlitchIn,
  GrowIn,
  PunchIn,
  ShapeIn,
  RevealIn,
  SlideIn,
  SpinIn,
  TiltIn,
  TurnIn,
  WinkIn
};
//# sourceMappingURL=index.js.map